import React from 'react'

import styled from 'styled-components'
import { Row, Col } from 'antd'

interface BoardGridProps {
  children: React.ReactNode;
  gutter?: [number, number];
  columns?: number;
}

const StyledRow = styled(Row)`
  width: 100%;
`

export const BoardGrid: React.FC<BoardGridProps> = ({
  children,
  gutter = [24, 24],
  columns = 4,
}) => {
  const childrenArray = React.Children.toArray(children)
  
  return (
    <StyledRow gutter={gutter}>
      {childrenArray.map((child, index) => (
        <Col key={index}
          xs={24}
          sm={12}
          md={8}
          lg={24 / columns}
        >
          {child}
        </Col>
      ))}
    </StyledRow>
  )
}